module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_fails.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_fails.js
// module chunks = 168707334958949